"use strict";

import PageProcessor from '../PageProcessor';

export default class GeneralPage extends PageProcessor {

	constructor() 
	{
		super();
	}

	/**
	 * Initialize processor
	 * @return
	 */
	initialize() 
	{
		let self = this;

		self.bindElements(self.settings);

		if (!self.readyForAttach()) {
			self.debug("Not ready for attach, returning...");
			return;
		}

		self.getContent()
			.then(content => {
				self.attachContent(content.style, content.html.finance)
					.then(() => self.afterAttachment(content.script));
			});

		if (!self.hasBeenInitialized) {
			self.hasBeenInitialized = true;

			self.appendCustomCssToHead(self.settings.display.customCSS);
			self.runScript(self.settings.display.customJS);
		}
	}

	/**
	 * Bind elements
	 * @param  {Object} settings
	 * @return
	 */
	bindElements(settings) {
		this.elementBinding.addElements({
			"insertContainer": settings.display.insertContainer,
			"sparxpresContent": "." + this.getWrapperClass()
		});
	}

}
